/**
 * Message formatting port (Sprint-017.2 FR-4).
 *
 * ICU MessageFormat is the canonical translation format, but the Localization
 * Service depends on this abstraction rather than on a concrete engine: the
 * formatter is swappable, testable without the ICU library, and no
 * language-specific grammar rule ever reaches the UI.
 *
 * The default implementation lives in `icu-message-formatter.ts`.
 */
export class MessageFormatError extends Error {
    kind;
    name = 'MessageFormatError';
    constructor(kind, message, cause) {
        super(message, cause !== undefined ? { cause } : undefined);
        this.kind = kind;
    }
}
//# sourceMappingURL=message-formatter.js.map